module.exports = __webpack_public_path__ + "static/media/Element_28@4x.268d0f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Element_28@4x.png
// module id = 450
// module chunks = 0